import {Map, List} from 'immutable';

import {
  RELATIONSHIP_LIST_REQUEST,
  RELATIONSHIP_LIST_SUCCESS,
  RELATIONSHIP_LIST_FAILURE,
  RELATIONSHIP_READ_REQUEST,
  RELATIONSHIP_READ_SUCCESS,
  RELATIONSHIP_READ_FAILURE,
  RELATIONSHIP_UPDATE_REQUEST,
  RELATIONSHIP_UPDATE_SUCCESS,
  RELATIONSHIP_UPDATE_FAILURE,
  RELATIONSHIP_CREATE_REQUEST,
  RELATIONSHIP_CREATE_SUCCESS,
  RELATIONSHIP_CREATE_FAILURE,
  RELATIONSHIP_DELETE_REQUEST,
  RELATIONSHIP_DELETE_SUCCESS,
  RELATIONSHIP_DELETE_FAILURE,
  RELATIONSHIP_FORM_DESTROY,
  RELATIONSHIP_CSV_DOWNLOAD_REQUEST,
  RELATIONSHIP_CSV_DOWNLOAD_SUCCESS,
  RELATIONSHIP_CSV_DOWNLOAD_FAILURE
} from './actions'
import Logger from '../../../lib/Logger';

export default function relationships(
  state=Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {}
  }),
  action
) {
  Logger.log('debug', `[relationships.reducers] relationships(%j, %j)`, state, action);

  switch(action.type) {

    case RELATIONSHIP_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case RELATIONSHIP_LIST_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        pages: {
          [action.order]: {
            [action.limit]: {
              [action.page]: null
            }
          }
        },
        total: action.total,
        lastUpdated: action.receivedAt
      }).setIn(['pages', action.order, action.limit, action.page], List(action.result));

    case RELATIONSHIP_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case RELATIONSHIP_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case RELATIONSHIP_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case RELATIONSHIP_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case RELATIONSHIP_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case RELATIONSHIP_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case RELATIONSHIP_UPDATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case RELATIONSHIP_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case RELATIONSHIP_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: parseInt(action.id),
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case RELATIONSHIP_CREATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case RELATIONSHIP_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case RELATIONSHIP_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case RELATIONSHIP_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case RELATIONSHIP_FORM_DESTROY:
      return state.mergeDeep({
        form: null
      }).set('form', action.form);

    case RELATIONSHIP_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true
      });

    case RELATIONSHIP_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case RELATIONSHIP_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `relationships.reducers loaded.`);
